module.exports = __webpack_public_path__ + "static/poster-man-v-food-ddab912023d4f6ae29a8626a939112b0.jpg";